export default "__VITE_PUBLIC_ASSET__fdce7d75__"